import { FC } from 'react';
import { Users } from '../../components/Users/Users';
import { useAppSelector } from '../../store/store';
import { selectRoles, selectToken } from '../../store/reducers/AuthSlice';
import { Navigate } from 'react-router-dom';
import { NotFoundScreen } from '../NotFoundScreen';

interface Props {
  allowedRoles: string[];
}

export const UsersScreen: FC<Props> = ({ allowedRoles }) => {
  const token = useAppSelector(selectToken);
  const roles = useAppSelector(selectRoles);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!roles?.find((role) => allowedRoles?.includes(role))) {
    return <NotFoundScreen />;
  }

  return <Users />;
};

UsersScreen.displayName = 'UsersScreen';
